import { Component, Input } from '@angular/core';
import { IHint } from '../../../services/actions/interfaces/action-config.interface';

@Component({
  selector: 'gtd-hints',
  templateUrl: './hints.component.html',
})
export class HintsComponent {
  @Input() hint: IHint;
}
